import { formatRelativeTime } from '@/shared/utils/format-relative-time';

interface PostFooterProps {
  label?: string;
  updatedAt: DateISOString;
}

export function PostFooter({ label = 'Uploaded', updatedAt }: PostFooterProps) {
  return (
    <div className="relative w-full border-t border-zinc-200">
      <div className="flex items-center justify-between px-4 py-2">
        <div className="text-sm text-zinc-500">
          {label} {formatRelativeTime(updatedAt)}
        </div>
      </div>
    </div>
  );
}
